"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Selected = exports.Deselected = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _colors = require("../colors");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

/* eslint-disable react/jsx-curly-brace-presence */
var Deselected =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Deselected, _PureComponent);

  function Deselected() {
    _classCallCheck(this, Deselected);

    return _possibleConstructorReturn(this, _getPrototypeOf(Deselected).apply(this, arguments));
  }

  _createClass(Deselected, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          width = _this$props.width,
          color = _this$props.color,
          backgroundColor = _this$props.backgroundColor;
      return _react["default"].createElement("svg", {
        width: width,
        height: width,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
        id: "radio-default-a",
        d: "M12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,\n            2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,12 C2.18181818,17.4224321 6.57756791,21.8181818 12,\n            21.8181818 Z M12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 C0,5.372583 5.372583,0 12,0 Z"
      })), _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        stroke: "black",
        strokeWidth: "0",
        fill: backgroundColor
      }), _react["default"].createElement("use", {
        fill: color,
        xlinkHref: "#radio-default-a"
      })));
    }
  }]);

  return Deselected;
}(_react.PureComponent);

exports.Deselected = Deselected;
Deselected.propTypes = {
  width: _propTypes["default"].string,
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
Deselected.defaultProps = {
  width: '16px',
  color: _colors.cobalt.base,
  backgroundColor: 'none'
};

var Selected =
/*#__PURE__*/
function (_PureComponent2) {
  _inherits(Selected, _PureComponent2);

  function Selected() {
    _classCallCheck(this, Selected);

    return _possibleConstructorReturn(this, _getPrototypeOf(Selected).apply(this, arguments));
  }

  _createClass(Selected, [{
    key: "render",
    // eslint-disable-line react/no-multi-comp
    value: function render() {
      var _this$props2 = this.props,
          width = _this$props2.width,
          color = _this$props2.color,
          backgroundColor = _this$props2.backgroundColor;
      return _react["default"].createElement("svg", {
        width: width,
        height: width,
        viewBox: "0 0 24 24"
      }, _react["default"].createElement("defs", null, _react["default"].createElement("path", {
        id: "selected-a",
        d: "M21.8181818,12 C21.8181818,6.57756791 17.4224321,2.18181818 12,2.18181818 C6.57756791,2.18181818 2.18181818,6.57756791 2.18181818,\n            12 C2.18181818,17.4224321 6.57756791,21.8181818 12,21.8181818 C17.4224321,21.8181818 21.8181818,17.4224321 21.8181818,12 Z M0,\n            12 C0,5.372583 5.372583,0 12,0 C18.627417,0 24,5.372583 24,12 C24,18.627417 18.627417,24 12,24 C5.372583,24 0,18.627417 0,12 Z M12,\n            17.4545455 C15.0124623,17.4545455 17.4545455,15.0124623 17.4545455,12 C17.4545455,8.98753773 15.0124623,6.54545455 12,6.54545455 C8.98753773,\n            6.54545455 6.54545455,8.98753773 6.54545455,12 C6.54545455,15.0124623 8.98753773,17.4545455 12,17.4545455 Z"
      })), _react["default"].createElement("g", {
        fill: "none",
        fillRule: "evenodd"
      }, _react["default"].createElement("circle", {
        cx: "12",
        cy: "12",
        r: "12",
        stroke: "black",
        strokeWidth: "0",
        fill: backgroundColor
      }), _react["default"].createElement("use", {
        fill: color,
        xlinkHref: "#selected-a"
      })));
    }
  }]);

  return Selected;
}(_react.PureComponent);

exports.Selected = Selected;
Selected.propTypes = {
  width: _propTypes["default"].string,
  color: _propTypes["default"].string,
  backgroundColor: _propTypes["default"].string
};
Selected.defaultProps = {
  width: '16px',
  color: _colors.teal.base,
  backgroundColor: 'none'
};